const ExternalLink = ({ className = '' }: { className?: string }) => (
  <svg
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M8.5 8L14.5 2V6.66667V2H9.83333'
      stroke='#442E83'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.5 2H3.83333C3.09667 2 2.5 2.59667 2.5 3.33333V12.6667C2.5 13.4033 3.09667 14 3.83333 14H13.1667C13.9033 14 14.5 13.4033 14.5 12.6667V10'
      stroke='#442E83'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default ExternalLink
